<template>
    <div id="messages">
        <ul>
            <li class="empty" v-show="messages.length === 0">Нет сообщений</li>
            <Message
                    v-for="message in messages"
                    :key="message.id"
                    :message="message"
            ></Message>
        </ul>
    </div>
</template>

<script>
    import jsonp from 'jsonp'
    import Message from './Message.vue'

    import Server from './../libs/server'

    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {}
        },
        components: {Message},
        computed: {
            ...mapState({
                'messages': state => state.messages.messageList
            })
        },
        methods: {
            ...mapActions([
                'getMessageList',
                'showError'
            ])
        },
        mounted: function () {
            this.getMessageList()
                .catch(err => {
                    this.showError(err);
                });
        }
    }
</script>

<style>
    #messages {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        overflow-y: scroll;
        z-index: 10;
        background: rgba(0, 0, 0, .75);
    }

    #messages li {
        list-style: none;
    }

    #messages li.empty {
        text-align: center;
        padding: 24px 6px;
    }
</style>


// WEBPACK FOOTER //
// MessagesList.vue?cf2fed20